import { __assign, __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import { HTML5Backend } from '../../node_modules/react-dnd-html5-backend/dist/index.js';
import { createDragDropManager } from '../../node_modules/dnd-core/dist/createDragDropManager.js';

var dndManager = createDragDropManager(HTML5Backend);
var removeNode = function (treeData, removedNode, currentLevel) {
    return treeData
        .filter(function (node) { return node.id !== removedNode.id; })
        .map(function (node) {
        if (node.children) {
            return __assign(__assign({}, node), { children: removeNode(node.children, removedNode) });
        }
        return node;
    });
};
var addNode = function (treeData, addedNode, index, parentChain) {
    var recursiveFindAndAdd = function (nodes, currentChain) {
        if (!currentChain.length) {
            return __spreadArray(__spreadArray(__spreadArray([], nodes.slice(0, index), true), [addedNode], false), nodes.slice(index), true);
        }
        return nodes.map(function (node) {
            if (node.id === currentChain[0].id) {
                return __assign(__assign({}, node), { children: recursiveFindAndAdd(node.children || [], currentChain.slice(1)) });
            }
            return node;
        });
    };
    return recursiveFindAndAdd(treeData, parentChain);
};
var getParentArray = function (parents, parent) {
    if (!parent)
        return parents;
    return getParentArray(__spreadArray([parent], parents, true), parent.parent);
};
var moveNode = function (treeData, _a) {
    var movedNode = _a.movedNode, newIndex = _a.newIndex, newParent = _a.newParent;
    var newData = removeNode(treeData, movedNode);
    var parentChain = newParent ? getParentArray([], newParent).map(function (x) { return x.data; }) : [];
    return addNode(newData, movedNode, newIndex, parentChain);
};
var getTreeMoveArgs = function (dragNode, dropNode, above) {
    var _a, _b;
    var nodeIsParent = !above && dropNode.data.children;
    var newParent = nodeIsParent ? dropNode : dropNode.parent;
    var newRawIndex = nodeIsParent ? 0 : above ? dropNode.index : dropNode.index + 1;
    var newIndex = ((_a = dragNode.parent) === null || _a === void 0 ? void 0 : _a.id) === ((_b = dropNode.parent) === null || _b === void 0 ? void 0 : _b.id) && newRawIndex > dragNode.index
        ? newRawIndex - 1
        : newRawIndex;
    return {
        movedNode: dragNode.data,
        newIndex: newIndex,
        previousIndex: dragNode.index,
        previousParent: dragNode.parent,
        newParent: newParent
    };
};

export { dndManager, getTreeMoveArgs, moveNode };
